<template lang="pug">
	.asset-preview-mini(v-if="showed" v-pseudo-modal="'asset-preview'" :style="{top: top + 'px', right: right + 'px'}")
		.img-asset-preview(v-if="asset && (asset.type === 'image' || asset.type === 'atlas')")
			.unsupported-format(v-if="assetText")
				i.fa.fa-exclamation-triangle
				span {{assetText}}
			img(v-if="assetURL" :src="assetURL")
		//- Видео-ассет: проигрываем сам файл без органов управления - с навигацией, паузой и звуком видео показывается
		//- в свойствах раскрытого ассета (см. Asset.getAssetVideoPreviewUrl)
		.video-asset-preview(v-if="asset && asset.type === 'video'")
			.unsupported-format(v-if="assetText")
				i.fa.fa-exclamation-triangle
				span {{assetText}}
			video(v-if="assetURL && !assetText" :src="assetURL" autoplay muted loop playsinline v-on:error="assetText = 'Unfortunately preview for this video is not available'")
		//- Проигрыватель Spine создаётся один раз и переиспользуется для всех ассетов: смена ассета не пересоздаёт скелет,
		//- разобранные данные берутся из общего кэша (см. SpinePlayer), а анимация не играется пока миниатюра скрыта.
		//- Анимация - выбранная пользователем последней в свойствах ассета (Asset.SpineSelections), иначе анимация по умолчанию
		SpinePlayer(v-if="spineAsset" v-show="asset === spineAsset" :json="spineAsset.options.json" :atlas="spineAsset.options.atlas" :imageUrl="spineAssetURL" :cacheKey="spineCacheKey" :skin="spineSelection.skin" :animation="spineSelection.animation" :playing="asset === spineAsset" :width="100" :height="100")

</template>

<script>

	import Screen 			from './../../mixins/screen';
	import { Creative } 		from './../../services/Creative';
	import { Version } 		from './../../services/Version';
	import { Asset } 		from './../../services/Asset';

	import SpinePlayer 		from './SpinePlayer';

	// Длительность кадра спрайтовой анимации при скорости 100% (соответствует PIXI.AnimatedSprite с animationSpeed = 1 при 60 fps)
	const SPRITES_ANIMATION_FRAME_DURATION = 1000 / 60;

	export default {
		name: "AssetPreviewMini",
		mixins: [Screen],
		components: {
			SpinePlayer
		},
		screen: {
			events: {
				"Show Asset Preview": function(asset, e, el) {

					if (Asset.isRandomAsset(asset) || !_.includes(['image', 'atlas', 'spine', 'video'], asset.type) || (asset.type === 'spine' && !(asset.options.json && asset.options.atlas && asset.url))) {
						this.asset = null;
						return;
					}

					this.asset = asset;

					let rect = el.getBoundingClientRect();

					this.top = rect.top;
					this.right = document.body.clientWidth - rect.left;

					this.assetPreviewIndex = 0;

					if (asset.type === 'video') {

						// Миниатюра видео: играем файл без звука - чтобы при наведении на ассет ничего не звучало
						this.assetURL = Asset.getAssetVideoPreviewUrl(asset);
						this.assetText = this.assetURL ? '' : 'This video asset has no content yet';

						this.update();

					} else if (asset.type === 'atlas' && asset.options.spritesAnimation) {

						this.assets = _.filter(Asset.getVersionAssets(Version.SelectedVersion), versionAsset => {

							return versionAsset.type === "image" && _.includes(versionAsset.options.atlases, asset.codename) && !versionAsset.Tags.disabled;

						});

						// Предзагрузим картинки - иначе они вообще не загружаются никогда (быстрая смена картинки не даёт програзиться)
						_.each(this.assets, asset => {

							let img = new Image();
							img.src = Asset.getAssetActualUrl(asset, {addTimestamp: true, imagesForAtlases: true, preview: true});

						});

						this.assetURL = Asset.getAssetActualUrl(this.assets[0], {addTimestamp: true, imagesForAtlases: true, preview: true});

						// Кадр вычисляется по прошедшему времени с учётом скорости анимации (animationSpeed) -
						// так же, как PIXI.AnimatedSprite в билде: при скорости 1 - один кадр за тик (60 fps).
						// Скорость читается на каждом тике, чтобы изменение настройки сразу отражалось в превью
						let atlasAsset = asset;
						let lastTime = performance.now();

						this.assetPreviewTime = 0;

						clearInterval(this.assetPreviewInterval);

						this.assetPreviewInterval = setInterval(() => {

							if (!this.assets.length) return;

							let now = performance.now();

							this.assetPreviewTime += (now - lastTime) * this.getAnimationSpeed(atlasAsset);
							lastTime = now;

							let index = Math.floor(this.assetPreviewTime / SPRITES_ANIMATION_FRAME_DURATION) % this.assets.length;

							if (index === this.assetPreviewIndex) return;

							this.assetPreviewIndex = index;

							this.assetURL = Asset.getAssetActualUrl(this.assets[index], {addTimestamp: true, imagesForAtlases: true, preview: true});

							this.update();

						}, SPRITES_ANIMATION_FRAME_DURATION);

					} else if (asset.type === 'spine') {

						// url ассета Spine - текстура атласа (.png)
						this.assetURL = Asset.getAssetActualUrl(asset);
						this.assetText = '';
						this.spineSelection = Asset.SpineSelections[`${asset['version_id']}-${asset.codename}`] || {};

						// Проигрыватель переиспользуется - меняются только данные ассета, а скелет берётся из общего кэша по ключу ассета
						this.spineAsset = asset;
						this.spineAssetURL = this.assetURL;
						this.spineCacheKey = Asset.getSpineCacheKey(asset);

						this.update();

					} else {

						if (!asset.isHDR) {

							this.assetURL = Asset.getAssetActualUrl(asset, {addTimestamp: true, imagesForAtlases: true, preview: true});
							this.assetText = '';

						} else {

							this.assetURL = '';
							this.assetText = 'Unfortunately preview for hdr assets is not available';

						}

						this.update();

					}

					Broadcast.call("Pseudo Modal Show", ["asset-preview"]);

				},
				"Hide Asset Preview": function() {

					this.asset = null;

					this.update();

					clearInterval(this.assetPreviewInterval);

					Broadcast.call("Pseudo Modal Hide", ["asset-preview"]);

				}
			}
		},
		data() {

			this.asset = null;
			this.assetURL = '';
			this.assetText = '';
			this.spineSelection = {};

			// Данные последнего показанного Spine ассета - проигрыватель миниатюры не пересоздаётся при наведении на другой ассет
			this.spineAsset = null;
			this.spineAssetURL = '';
			this.spineCacheKey = null;

			return {
				showed: true,
				top: 0,
				right: 0
			};

		},
		computed: {

		},
		methods: {
			collectData() {

			},
			// Скорость спрайтовой анимации из настроек атласа (как в билде: не задана - 1)
			getAnimationSpeed(asset) {

				let speed = parseFloat(asset && asset.options && asset.options.animationSpeed);

				return speed > 0 ? speed : 1;

			}
		}
	}
</script>

<style lang="sass">

	.asset-preview-mini
		position: absolute
		z-index: 10000
		top: 0
		right: 0
		border-radius: 0.25rem
		padding: 0.25rem
		border: 1px solid #23282c
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
		background-color: #3a4149

		.img-asset-preview


			i
				padding-right: 10px
			i, span
				color: #ff9a47

			img
				max-width: 100px
				max-height: 100px

		.video-asset-preview

			i
				padding-right: 10px
			i, span
				color: #ff9a47

			video
				display: block
				max-width: 100px
				max-height: 100px
				background-color: #000

</style>
